import React from 'react';

/**
 * Renders a search-highlight string as React nodes.
 *
 * Azure Cognitive Search wraps matched terms in <em>…</em>; everything else in
 * the string is document-derived text and must never reach the DOM as markup —
 * a document titled `<img src=x onerror=…>` would execute for whoever searched
 * for it. Parsing into elements lets React escape the text, which removes the
 * dangerouslySetInnerHTML this replaces; only the <em> pairs survive, as
 * emphasis elements.
 */
const EM_SPLIT = /<em>(.*?)<\/em>/g;

export function renderHighlightedText(text: string): React.ReactNode {
  const parts = text.split(EM_SPLIT);
  if (parts.length === 1) return text;
  // split() with one capture group alternates plain / highlighted segments.
  return parts.map((part, i) =>
    i % 2 === 1 ? <em key={i}>{part}</em> : part,
  );
}
